export const GET_BLOCKS = 'blocks/get';
export const GET_BLOCKS_SUCCESS = 'blocks/get/success';

export const GET_BLOCK = 'block/get';
export const GET_BLOCK_SUCCESS = 'block/get/success';
